<div style="position: relative;">
  <div *ngIf="artists" class="d-flex flex-row flex-wrap">
    <div class="flex-50 flex-sm-33 flex-md-25">
      <app-artist-carousel-item #itemSwiper [index]="0" [artists]="artists" [config]="config"></app-artist-carousel-item>
    </div>
    <div class="flex-50 flex-sm-33 flex-md-25">
      <app-artist-carousel-item #itemSwiper [index]="1" [artists]="artists" [config]="config"></app-artist-carousel-item>
    </div>
    <div class="d-none d-sm-block flex-50 flex-sm-33 flex-md-25">
      <app-artist-carousel-item #itemSwiper [index]="2" [artists]="artists" [config]="config"></app-artist-carousel-item>
    </div>
    <div class="d-none d-md-block flex-50 flex-sm-33 flex-md-25">
      <app-artist-carousel-item #itemSwiper [index]="3" [artists]="artists" [config]="config"></app-artist-carousel-item>
    </div>
  </div>
  <div class="swiper-button-prev-artists">
    <a aria-label="Previous" (click)="slidePrev()" color="primary" role="button">
      <mat-icon color="primary">arrow_circle_left</mat-icon>
    </a>
  </div>
  <div class="swiper-button-next-artists">
    <a aria-label="Next" (click)="slideNext()" color="primary" role="button">
      <mat-icon color="primary">arrow_circle_right</mat-icon>
    </a>
  </div>
</div>
